import { render, staticRenderFns } from "./selected-section-video.vue?vue&type=template&id=6f3400be&scoped=true"
import script from "./selected-section-video.vue?vue&type=script&lang=js"
export * from "./selected-section-video.vue?vue&type=script&lang=js"
import style0 from "./selected-section-video.vue?vue&type=style&index=0&id=6f3400be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3400be",
  null
  
)

export default component.exports